
export const styleClasses = {
  wrapper: "untrusive-wrapper",
  wrapper_active: "untrusive-active",
  bar: "untrusive-bar",
};
